import { path as ramdaPath } from 'ramda';
import { metrics } from 'system/libs/metrics';
import notify from 'system/mediators/NotifyManager';
import { YandexMetrica } from 'utilities/YandexMetrica';

import s3 from '../../s3';
import { actionListAdd } from './list';

export const BUCKETS_CREATE_START = 'BUCKETS_CREATE_START';
export function actionCreateStart() {
    return {
        type: BUCKETS_CREATE_START,
    };
}

export const BUCKETS_CREATE_CANCEL = 'BUCKETS_CREATE_CANCEL';
export function actionCreateCancel() {
    return {
        type: BUCKETS_CREATE_CANCEL,
    };
}

export const BUCKETS_CREATE_REQUEST = 'BUCKETS_CREATE_REQUEST';
export function actionCreateRequest() {
    return {
        type: BUCKETS_CREATE_REQUEST,
    };
}

export const BUCKETS_CREATE_SUCCESS = 'BUCKETS_CREATE_SUCCESS';
export function actionCreateSuccess() {
    return {
        type: BUCKETS_CREATE_SUCCESS,
    };
}

export const BUCKETS_CREATE_FAILURE = 'BUCKETS_CREATE_FAILURE';
export function actionCreateFailure({ error }) {
    return {
        type: BUCKETS_CREATE_FAILURE,
        data: { error },
    };
}

async function getIsBucketExists(Name) {
    try {
        await s3('headBucket', { Bucket: Name });

        return true;
    } catch (error) {
        const statusCode = getResponceStatusCode(error);

        return statusCode === 403;
    }
}

function getResponceStatusCode(responce) {
    return ramdaPath(['error', 'statusCode'], responce);
}

function _sendMetrics() {
    metrics.send({
        eventName: 'PlatformEvents',
        category: 'mcsplatform',
        action: 'bucket',
    });

    YandexMetrica.reachGoal('bucket');
}

export function asyncActionCreate({ Name, StorageClass, isEdit }) {
    return async function(dispatch) {
        let error = '';

        Name = Name.trim();

        if (!Name) {
            error = 'required';
        } else if (!isEdit && (await getIsBucketExists(Name))) {
            error = 'BucketAlreadyExists';
        } else {
            dispatch(actionCreateRequest());

            try {
                await s3(
                    'createBucket',
                    { Bucket: Name },
                    {
                        headers: {
                            'x-mcs-storage-class': StorageClass,
                        },
                    },
                );

                dispatch(actionCreateSuccess());
                dispatch(
                    actionListAdd({
                        Bucket: {
                            Name,
                            CreationDate: new Date(),
                        },
                    }),
                );

                _sendMetrics();
            } catch (reason) {
                const codes = [
                    'BucketNameWrong',
                    'BucketAlreadyExists',
                    'BucketLimitExceeded',
                ];
                const code = ramdaPath(['error', 'code'], reason);

                if (codes.includes(code)) {
                    error = code;
                } else {
                    error = 'unknown';
                    notify.error('Не удалось создать бакет');
                }
            }
        }

        if (error) {
            dispatch(actionCreateFailure({ error }));
            throw error;
        }
    };
}
